<app-element-select displayLabel='Select Person'
                    [defaultValue]="defaultPersonSelected"
                    [options]="personsNameValueDTO"
                    [emitNameValueDTO]="true"
                    (selectionChanged)="onSelectionChange($event)"
                    [customCssClasses]="['w-20']">
</app-element-select>

<ng-container *ngIf="isDataExist; else emptySmsDataTable">
  <greydom-sms-table
    [smsDataSource]="smsDataSource"
    [smsTableControl]="smsTableControl"
    [smsDisplayedColumns]="smsDisplayedColumns"
    [dateTimeFormat]="dateTimeFormat"
    [smsExpandedRow]="smsExpandedRow"
    [smsOverrideFormControl]="smsOverrideFormControl"
    (sortData)="sortData($event)"
    (rowClicked)="onRowClick($event.event, $event.row)"
    (sendSmsConfirmed)="onClickSendSmsConfirmed($event.event, $event.row)"
    (toggleIcons)="onClickToggleIcons($event.event, $event.row)"
    (editNumber)="onClickEditNumber($event.event, $event.row)"
    (cancelEditNumber)="onClickCancelEditNumber($event.event, $event.row)"
    (saveNumber)="onClickSaveNumber($event.event, $event.row)"
    (duplicate)="OnClickDuplicate($event.duplicate, $event.row)">
  </greydom-sms-table>

</ng-container>

<ng-template #emptySmsDataTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No sms data</label>
  </div>
</ng-template>
